'use strict';

var React = require('react');

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var Button = require('components/ui/button');

var ModuleInspectorPropertyTypeButtonGroup = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeButtonGroup',

  render: function render() {
    var component = this;
    var props = component.props;

    var buttonNodes = props.buttons.map(function (button) {
      return React.createElement(Button, {
        key: button.name,
        value: ModuleInspectorStore.translate(props.groupName + '_' + props.name + '_' + button.name),
        onClick: component._onPerformAction.bind(null, button.name) });
    });

    return React.createElement(
      TitledGroup,
      { title: ModuleInspectorStore.translate(props.groupName + '_' + props.name), className: 'property-component' },
      buttonNodes
    );
  },

  _onPerformAction: function _onPerformAction(buttonName) {
    var component = this;
    var props = component.props;

    if (props.onPerformAction) {
      props.onPerformAction(buttonName);
    }
  }
});

module.exports = ModuleInspectorPropertyTypeButtonGroup;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/button-group.js
 **/